import { cva, type VariantProps } from 'class-variance-authority';
import classNames from 'classnames';
import type { FC } from 'react';

export const htmlContentStyles = cva(
  'flex flex-col gap-5 font-inter text-body [&_h1]:text-h1 [&_h2]:text-h2 [&_h3]:text-h3 [&_h4]:text-h4 [&_h5]:text-h5 [&_img]:rounded-lg [&_ol]:list-inside [&_ol]:list-decimal [&_p>img]:inline-flex [&_ul]:list-inside [&_ul]:list-disc',
  {
    variants: {
      variant: {
        cmsContent: `w-full text-neutral-100 [&_a]:underline 
          [&_h1]:my-2 [&_h2]:my-2
          [&_h3]:my-2 [&_h4]:my-2
          [&_h5]:my-2 [&_p]:mb-2
          [&_table_td]:border [&_table_td]:border-[#80808080]
          [&_table_td]:p-4 [&_table_th]:border
          [&_table_th]:border-[#80808080]
          [&_table_th]:p-4 [&_table_tr:first-child_td]:text-center [&_tr:nth-child(odd)_td]:bg-[#80808012]`,
      },
    },
    defaultVariants: {
      variant: 'cmsContent',
    },
  }
);

type HtmlContentProps = {
  content: string;
  className?: string;
} & VariantProps<typeof htmlContentStyles>;

const HtmlContent: FC<HtmlContentProps> = ({ content, variant, className }) => {
  return (
    <div
      className={classNames(htmlContentStyles({ variant }), className)}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default HtmlContent;
